import React, {useEffect, useState} from 'react'
import {useParams} from "react-router-dom"
//************************************//
import LoadingIndicator from "@src/components/LoadingIndicator"
//************************************//
import ManageCustomFieldsIndex from "./ManageCustomFieldsIndex"
import {_showAssignmentSettingCustomFields} from "@csrc/modules/assignment/redux/actions"
//************************************//
const TypeDetail = () => {
	//************************************//
	const [loadingData, setLoadingData] = useState(true)
	const [customFields, setCustomFields] = useState({})
	//************************************//
  const {uuid} = useParams()
//************************************//
  useEffect(() => {
    _showAssignmentSettingCustomFields(
      data => {
        setCustomFields({
          entityCustomFieldsList: [
            {
              key: "group1",
              is_used: true,
              name: "",
              description: "",
              field_type: "group",
              is_required: false,
              default_value: {
                value: ""
              },
              config: [],
              parent_id: null
            },
            ..._.map(data.fields, x => ({...x, parent_id: "group1"}))
          ],
          unusedCustomFieldsList: data.unused_fields,
          entityData: data
        })
        setLoadingData(false)
      }
    )
  }, [])
  //************************************//
  return (
		<LoadingIndicator loading={loadingData}>
      <ManageCustomFieldsIndex
        uuid={uuid}
        customFieldsState={{customFields, setCustomFields}}
      />
    </LoadingIndicator>
  )
}
//************************************//
export default TypeDetail
